export default "__VITE_ASSET__BcxKin3K__"